import { render, staticRenderFns } from "./mate-code.vue?vue&type=template&id=87a271cc&scoped=true"
import script from "./mate-code.vue?vue&type=script&lang=js"
export * from "./mate-code.vue?vue&type=script&lang=js"
import style0 from "./mate-code.vue?vue&type=style&index=0&id=87a271cc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a271cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87a271cc')) {
      api.createRecord('87a271cc', component.options)
    } else {
      api.reload('87a271cc', component.options)
    }
    module.hot.accept("./mate-code.vue?vue&type=template&id=87a271cc&scoped=true", function () {
      api.rerender('87a271cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/main-data/mate-code/mate-code.vue"
export default component.exports